import { homeService } from "services";
import { homeConstants } from "../constants";

export const homeActions = {
  getProductsList,
  getTopTenProducts,
  getProductPartialSearch,
  getProductDetails,
  getInsutranceList,
  resetInsuranceData,
  saveSelectedProduct,
  getCityStateForZipCode,
  getCityStateForZipCodeError,
  savedevicelocation,
  setCurrentLocation,
  saveCurrentLocationData,
  getRetailPrice,
  getDiscountPrice,
  updateRetailPrice,
  updateDiscountPrice,
  saveInsuranceData,
  resetInsuranceFilterData,
  getRecentSearchList,
  resetData,
  saveDosage,
  saveForm,
  saveQuantity,
  signIn,
  loginEncUser,
  signOut,
  signUp,
  forgotPassword,
  passwordChange,
  getMessagesList,
  myCoupons,
  deleteCoupon,
  saveProfile,
  contactUs,
  cuverdSettings,
  getNotifications,
  clearRecentSearches,
  verifyForgotPassword,
  verifyPasswordChange,
  verifyResendPasswordChange,
  verifyPhonenumberChange,
  verifyEmailChange,
  getContentType,
  getProfile,
  emailChange,
  phoneChange,
  accountResendAttempt,
  resetAccountChangeData,
  resetLoginStatus,
  loginForgotPassword,
  loginResendForgotPassword,
  loginVerifyForgotPassword,
  resetLoginForgotPasswordStatus,
  resetSignUpStatus,
  searchRadius,
  saveCoupon,
  resetSavedCouponInfo,
  resetDeleteCouponInfo,
  getReminderTimeZones,
  getReminderDates,
  getDoseReminderData,
  getRefillSavingsData,
  saveDoseReminder,
  resetDoseReminderInfo,
  saveRefillReminder,
  resetRefillReminderInfo,
  sendEmailMessage,
  resetSendEmailInfo,
  sendTextMessage,
  resetSendTextInfo,
  shareHCPCoupon,
  resetHCPSendTextInfo,
  resetPasswordChange,
  getMessagesCount,
  markAsReadMessage,
  deleteMessage,
  markAllMessagesAsRead,
  deleteAllMessages,
  allowEmailNotifications,
  denyEmailNotifications,
  allowTextNotifications,
  denyTextNotifications,
  resetNotificationsSettings,
  validateCouponItem,
  resetverifyCouponValidation,
  selectMyCoupon,
  saveUserInsurance,
  resetZipStatus,
  getInsuranceDetail,
  sortByPrice,
  storeAppData,
  getPlaystoreLink,
  getCommunicationPreferences,
  saveCommunicationPreferences,
  saveZipCodeToServer,
  resetSaveProfile,
  resetLoginForgotPasswordResend,
  resetDoseReminderData,
  resetRefillSavingsData,
  getGTMDataLayer,
  updateGTMDataLayer,
  getDeviceDetails,
  getAppSettingsIdentity,
  resetSettingsIdentity,
  getPrescriptionProducts,
  getFireBaseNotification,
};

function signIn(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.signIn(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.SIGN_IN_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.SIGN_IN_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.SIGN_IN_FAILURE, error };
  }
}

function loginEncUser(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.loginEncUser(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.SIGN_IN_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.SIGN_IN_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.SIGN_IN_FAILURE, error };
  }
}

function signOut(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.signOut(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.SIGN_OUT_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.SIGN_OUT_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.SIGN_OUT_FAILURE, error };
  }
}

function signUp(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.signUp(params).then(
      (users) => dispatch(success(users)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.SIGN_UP_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.SIGN_UP_SUCCESS, response, params };
  }
  function failure(error) {
    return { type: homeConstants.SIGN_UP_FAILURE, error };
  }
}

function forgotPassword(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.forgotPassword(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.FORGOT_PASSWORD_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.FORGOT_PASSWORD_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.FORGOT_PASSWORD_FAILURE, error };
  }
}

function passwordChange(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.passwordChange(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.CHANGE_PASSWORD_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.CHANGE_PASSWORD_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.CHANGE_PASSWORD_FAILURE, error };
  }
}

function resetPasswordChange() {
  return { type: homeConstants.RESET_CHANGE_PASSWORD_DATA, data: null };
}

function getProductsList() {
  return (dispatch) => {
    dispatch(request());

    homeService.getProductsList().then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.PRODUCTS_LIST_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.PRODUCTS_LIST_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.PRODUCTS_LIST_FAILURE, error };
  }
}

function getTopTenProducts() {
  return (dispatch) => {
    dispatch(request());

    homeService.getTopTenProducts().then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.TOP_TEN_PRODUCTS_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.TOP_TEN_PRODUCTS_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.TOP_TEN_PRODUCTS_FAILURE, error };
  }
}

function getProductPartialSearch(value) {
  return (dispatch) => {
    dispatch(request());

    homeService.getProductPartialSearch(value).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.PRODUCTS_SEARCH_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.PRODUCTS_SEARCH_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.PRODUCTS_SEARCH_FAILURE, error };
  }
}

function saveSelectedProduct(value) {
  return { type: homeConstants.SELECTED_PRODUCT, product: value };
}

function saveInsuranceData(value) {
  if (value?.type !== "W") {
    localStorage.setItem("hasUserSelectedInsurance", "Y");
  } else {
    localStorage.setItem("hasUserSelectedInsurance", "N");
  }
  return { type: homeConstants.SELECTED_INSURANCE, insurance: value };
}

function resetInsuranceData() {
  return { type: homeConstants.RESET_SELECTED_INSURANCE };
}

function getProductDetails(value) {
  return (dispatch) => {
    dispatch(request());

    homeService.getProductDetails(value).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.PRODUCT_DETAILS_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.PRODUCT_DETAILS_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.PRODUCT_DETAILS_FAILURE, error };
  }
}

function getInsutranceList(value, type = "") {
  return (dispatch) => {
    dispatch(request());

    homeService.getInsutranceList(value, type).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.PRODUCT_INSURANCE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.PRODUCT_INSURANCE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.PRODUCT_INSURANCE_FAILURE, error };
  }
}

function resetInsuranceFilterData() {
  return { type: homeConstants.PRODUCT_INSURANCE_RESET };
}

function getCityStateForZipCodeError(error) {
  return { type: homeConstants.ZIP_SEARCH_RESULTS_FAILURE, error };
}

function getCityStateForZipCode(value) {
  return (dispatch) => {
    dispatch(request());

    homeService.getCityStateForZipCode(value).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.ZIP_SEARCH_RESULTS_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.ZIP_SEARCH_RESULTS_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.ZIP_SEARCH_RESULTS_FAILURE, error };
  }
}

function savedevicelocation(currentLocation) {
  return (dispatch) => {
    dispatch(request());

    homeService.savedevicelocation(currentLocation).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.ZIP_SEARCH_RESULTS_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.ZIP_SEARCH_RESULTS_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.ZIP_SEARCH_RESULTS_FAILURE, error };
  }
}

function saveCurrentLocationData(response) {
  return { type: homeConstants.ZIP_SEARCH_RESULTS_SUCCESS, response };
}

function setCurrentLocation(currentLocation) {
  return {
    type: homeConstants.SET_CURRENT_LOCATION,
    currentLocation,
  };
}

function getRetailPrice(data) {
  return (dispatch) => {
    dispatch(request());
    homeService.getRetailPrice(data).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.RETAIL_PRICE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.RETAIL_PRICE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.RETAIL_PRICE_FAILURE, error };
  }
}

function updateRetailPrice(data) {
  return (dispatch) => {
    return dispatch({ type: homeConstants.RETAIL_PRICE_UPDATE, data });
  };
}

function updateDiscountPrice(data) {
  return (dispatch) => {
    return dispatch({ type: homeConstants.DISCOUNT_PRICE_UPDATE, data });
  };
}

function getDiscountPrice(data) {
  return (dispatch) => {
    dispatch(request());

    homeService.getDiscountPrice(data).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.DISCOUNT_PRICE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.DISCOUNT_PRICE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.DISCOUNT_PRICE_FAILURE, error };
  }
}

function resetData(type) {
  return { type: homeConstants.RESET_DATA, data: type };
}

function resetAccountChangeData() {
  return { type: homeConstants.RESET_ACCOUNT_CHANGE_DATA, data: null };
}

function resetLoginStatus() {
  return { type: homeConstants.RESET_LOGIN_STATUS, data: null };
}

function getRecentSearchList() {
  return (dispatch) => {
    dispatch(request());

    homeService.getRecentSearchList().then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.RECENT_SEARCH_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.RECENT_SEARCH_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.RECENT_SEARCH_FAILURE, error };
  }
}

function saveDosage(value) {
  return { type: homeConstants.SELECTED_DOSAGE, data: value };
}

function saveForm(value) {
  return { type: homeConstants.SELECTED_FORM, data: value };
}

function saveQuantity(value) {
  return { type: homeConstants.SELECTED_QUANTITY, data: value };
}

function getMessagesList(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.getMessagesList(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.MESSAGES_LIST_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.MESSAGES_LIST_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.MESSAGES_LIST_FAILURE, error };
  }
}

function getMessagesCount(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.getMessagesCount(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.MESSAGES_COUNT_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.MESSAGES_COUNT_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.MESSAGES_COUNT_FAILURE, error };
  }
}

function markAsReadMessage(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.markAsReadMessage(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.MESSAGE_MARK_AS_READ_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.MESSAGE_MARK_AS_READ_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.MESSAGE_MARK_AS_READ_FAILURE, error };
  }
}

function deleteMessage(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.deleteMessage(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.MESSAGE_DELETE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.MESSAGE_DELETE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.MESSAGE_DELETE_FAILURE, error };
  }
}

function markAllMessagesAsRead(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.markAllMessagesAsRead(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.MESSAGES_MARK_ALL_READ_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.MESSAGES_MARK_ALL_READ_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.MESSAGES_MARK_ALL_READ_FAILURE, error };
  }
}

function deleteAllMessages(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.deleteAllMessages(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.MESSAGES_DELETE_ALL_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.MESSAGES_DELETE_ALL_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.MESSAGES_DELETE_ALL_FAILURE, error };
  }
}

function myCoupons(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.myCoupons(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.MY_COUPONS_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.MY_COUPONS_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.MY_COUPONS_FAILURE, error };
  }
}

function deleteCoupon(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.deleteCoupon(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.DELETE_COUPON_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.DELETE_COUPON_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.DELETE_COUPON_FAILURE, error };
  }
}

function getProfile(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.getProfile(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.GET_PROFILE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.GET_PROFILE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.GET_PROFILE_FAILURE, error };
  }
}

function saveProfile(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.saveProfile(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.SAVE_PROFILE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.SAVE_PROFILE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.SAVE_PROFILE_FAILURE, error };
  }
}

function contactUs(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.contactUs(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.CONTACT_US_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.CONTACT_US_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.CONTACT_US_FAILURE, error };
  }
}

function cuverdSettings(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.cuverdSettings(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.CUVERD_SETTINGS_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.CUVERD_SETTINGS_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.CUVERD_SETTINGS_FAILURE, error };
  }
}

function getNotifications(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.getNotifications(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.NOTIFICATIONS_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.NOTIFICATIONS_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.NOTIFICATIONS_FAILURE, error };
  }
}

function clearRecentSearches() {
  return (dispatch) => {
    dispatch(request());

    homeService.clearRecentSearches().then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.CLEAR_RECENT_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.CLEAR_RECENT_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.CLEAR_RECENT_FAILURE, error };
  }
}

function verifyForgotPassword(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.verifyForgotPassword(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.VERIFY_FORGOT_PASSWORD_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.VERIFY_FORGOT_PASSWORD_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.VERIFY_FORGOT_PASSWORD_FAILURE, error };
  }
}

function verifyResendPasswordChange(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.verifyResendPasswordChange(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.VERIFY_RESEND_PASSWORD_CHANGE_REQUEST };
  }
  function success(response) {
    return {
      type: homeConstants.VERIFY_RESEND_PASSWORD_CHANGE_SUCCESS,
      response,
    };
  }
  function failure(error) {
    return { type: homeConstants.VERIFY_RESEND_PASSWORD_CHANGE_FAILURE, error };
  }
}

function verifyPasswordChange(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.verifyPasswordChange(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.VERIFY_PASSWORD_CHANGE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.VERIFY_PASSWORD_CHANGE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.VERIFY_PASSWORD_CHANGE_FAILURE, error };
  }
}

function verifyPhonenumberChange(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.verifyPhonenumberChange(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.VERIFY_PHONE_NUMBER_CHANGE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.VERIFY_PHONE_NUMBER_CHANGE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.VERIFY_PHONE_NUMBER_CHANGE_FAILURE, error };
  }
}

function verifyEmailChange(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.verifyEmailChange(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.VERIFY_EMAIL_CHANGE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.VERIFY_EMAIL_CHANGE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.VERIFY_EMAIL_CHANGE_FAILURE, error };
  }
}

function getContentType(type) {
  return (dispatch) => {
    dispatch(request());

    homeService.getContentType(type).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.GET_CONTENT_TYPE_REQUEST };
  }
  function success(response) {
    return {
      type: homeConstants.GET_CONTENT_TYPE_SUCCESS,
      response,
      contentType: type,
    };
  }
  function failure(response) {
    return {
      type: homeConstants.GET_CONTENT_TYPE_FAILURE,
      response,
      contentType: type,
    };
  }
}

function emailChange(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.emailChange(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.CHANGE_EMAIL_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.CHANGE_EMAIL_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.CHANGE_EMAIL_FAILURE, error };
  }
}

function phoneChange(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.phoneChange(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.CHANGE_PHONE_NUMBER_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.CHANGE_PHONE_NUMBER_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.CHANGE_PHONE_NUMBER_FAILURE, error };
  }
}

function accountResendAttempt(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.accountResendAttempt(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.ACCOUNT_RESEND_ATTEMPT_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.ACCOUNT_RESEND_ATTEMPT_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.ACCOUNT_RESEND_ATTEMPT_FAILURE, error };
  }
}

function loginForgotPassword(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.loginForgotPassword(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.LOGIN_FORGOT_PASSWORD_REQUEST };
  }
  function success(response) {
    return {
      type: homeConstants.LOGIN_FORGOT_PASSWORD_SUCCESS,
      response,
      params,
    };
  }
  function failure(error) {
    return { type: homeConstants.LOGIN_FORGOT_PASSWORD_FAILURE, error };
  }
}

function loginResendForgotPassword(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.loginResendForgotPassword(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.LOGIN_FORGOT_PASSWORD_RESEND_REQUEST };
  }
  function success(response) {
    return {
      type: homeConstants.LOGIN_FORGOT_PASSWORD_RESEND_SUCCESS,
      response,
    };
  }
  function failure(error) {
    return { type: homeConstants.LOGIN_FORGOT_PASSWORD_RESEND_FAILURE, error };
  }
}

function loginVerifyForgotPassword(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.loginVerifyForgotPassword(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.LOGIN_FORGOT_PASSWORD_VERIFY_REQUEST };
  }
  function success(response) {
    return {
      type: homeConstants.LOGIN_FORGOT_PASSWORD_VERIFY_SUCCESS,
      response,
    };
  }
  function failure(error) {
    return { type: homeConstants.LOGIN_FORGOT_PASSWORD_VERIFY_FAILURE, error };
  }
}

function resetLoginForgotPasswordStatus() {
  return { type: homeConstants.RESET_LOGIN_FORGOT_PASSWORD_STATUS, data: null };
}

function resetLoginForgotPasswordResend() {
  return { type: homeConstants.LOGIN_FORGOT_PASSWORD_RESEND_RESET, data: null };
}

function resetSignUpStatus() {
  return { type: homeConstants.RESET_SIGN_UP_STATUS, data: null };
}

function searchRadius() {
  return (dispatch) => {
    dispatch(request());

    homeService.searchRadius().then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.SEARCH_RADIUS_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.SEARCH_RADIUS_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.SEARCH_RADIUS_FAILURE, error };
  }
}

function saveCoupon(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.saveCoupon(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.SAVE_COUPON_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.SAVE_COUPON_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.SAVE_COUPON_FAILURE, error };
  }
}

function resetSavedCouponInfo() {
  return { type: homeConstants.RESET_SAVED_COUPON_INFO, data: null };
}

function resetDeleteCouponInfo() {
  return { type: homeConstants.RESET_DELETE_COUPON_INFO, data: null };
}

function getReminderTimeZones(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.getReminderTimeZones(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.REMINDER_TIME_ZONE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.REMINDER_TIME_ZONE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.REMINDER_TIME_ZONE_FAILURE, error };
  }
}
function getRefillSavingsData(productDetailId) {
  return (dispatch) => {
    dispatch(request());

    homeService.getRefillSavingsData(productDetailId).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.REFILL_SAVINGS_DATA_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.REFILL_SAVINGS_DATA_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.REFILL_SAVINGS_DATA_FAILURE, error };
  }
}

function getReminderDates(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.getReminderDates(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.REMINDER_DATES_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.REMINDER_DATES_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.REMINDER_DATES_FAILURE, error };
  }
}

function getDoseReminderData(productDetailId) {
  return (dispatch) => {
    dispatch(request());

    homeService.getDoseReminderData(productDetailId).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error.toString()))
    );
  };

  function request() {
    return { type: homeConstants.DOSE_REMINDER_DATA_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.DOSE_REMINDER_DATA_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.DOSE_REMINDER_DATA_FAILURE, error };
  }
}

function resetDoseReminderData() {
  return { type: homeConstants.RESET_DOSE_REMINDER_DATA, data: null };
}

function resetRefillSavingsData() {
  return { type: homeConstants.RESET_REFILL_SAVINGS_DATA, data: null };
}

function saveDoseReminder(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.saveDoseReminder(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.SAVE_DOSE_REMINDER_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.SAVE_DOSE_REMINDER_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.SAVE_DOSE_REMINDER_FAILURE, error };
  }
}

function resetDoseReminderInfo() {
  return { type: homeConstants.RESET_DOSE_REMINDER_INFO, data: null };
}

function saveRefillReminder(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.saveRefillReminder(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.SAVE_REFILL_REMINDER_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.SAVE_REFILL_REMINDER_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.SAVE_REFILL_REMINDER_FAILURE, error };
  }
}

function resetRefillReminderInfo() {
  return { type: homeConstants.RESET_REFILL_REMINDER_INFO, data: null };
}

function sendEmailMessage(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.sendEmailMessage(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.SEND_EMAIL_MESSAGE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.SEND_EMAIL_MESSAGE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.SEND_EMAIL_MESSAGE_FAILURE, error };
  }
}

function resetSendEmailInfo() {
  return { type: homeConstants.RESET_SEND_EMAIL_MESSAGE_INFO, data: null };
}

function sendTextMessage(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.sendTextMessage(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.SEND_TEXT_MESSAGE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.SEND_TEXT_MESSAGE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.SEND_TEXT_MESSAGE_FAILURE, error };
  }
}

function resetSendTextInfo() {
  return { type: homeConstants.RESET_SEND_TEXT_MESSAGE_INFO, data: null };
}

function shareHCPCoupon(params) {
  return (dispatch) => {
    dispatch(request());

    homeService.shareHCPCoupon(params).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.SEND_HCP_TEXT_MESSAGE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.SEND_HCP_TEXT_MESSAGE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.SEND_HCP_TEXT_MESSAGE_FAILURE, error };
  }
}

function resetHCPSendTextInfo() {
  return { type: homeConstants.RESET_SEND_HCP_TEXT_MESSAGE_INFO, data: null };
}

function allowEmailNotifications() {
  return (dispatch) => {
    dispatch(request());

    homeService.allowEmailNotifications().then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.ALLOW_EMAIL_NOTIFICATIONS_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.ALLOW_EMAIL_NOTIFICATIONS_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.ALLOW_EMAIL_NOTIFICATIONS_FAILURE, error };
  }
}

function denyEmailNotifications() {
  return (dispatch) => {
    dispatch(request());

    homeService.denyEmailNotifications().then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.DENY_EMAIL_NOTIFICATIONS_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.DENY_EMAIL_NOTIFICATIONS_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.DENY_EMAIL_NOTIFICATIONS_FAILURE, error };
  }
}

function allowTextNotifications() {
  return (dispatch) => {
    dispatch(request());

    homeService.allowTextNotifications().then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.ALLOW_TEXT_NOTIFICATIONS_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.ALLOW_TEXT_NOTIFICATIONS_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.ALLOW_TEXT_NOTIFICATIONS_FAILURE, error };
  }
}

function denyTextNotifications() {
  return (dispatch) => {
    dispatch(request());

    homeService.denyTextNotifications().then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.DENY_TEXT_NOTIFICATIONS_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.DENY_TEXT_NOTIFICATIONS_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.DENY_TEXT_NOTIFICATIONS_FAILURE, error };
  }
}

function resetNotificationsSettings() {
  return { type: homeConstants.RESET_NOTIFICATIONS_REMINDER_INFO, data: null };
}

function validateCouponItem(saveCouponId) {
  return (dispatch) => {
    dispatch(request());

    homeService.validateCouponItem(saveCouponId).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.VALIDATE_COUPON_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.VALIDATE_COUPON_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.VALIDATE_COUPON_FAILURE, error };
  }
}

function resetverifyCouponValidation() {
  return { type: homeConstants.RESET_VALIDATE_COUPON, data: null };
}

function resetSaveProfile() {
  return { type: homeConstants.RESET_SAVE_PROFILE, data: null };
}

function selectMyCoupon(item) {
  return { type: homeConstants.SELECTED_COUPON_INFO, data: item };
}

function saveUserInsurance(insuranceId) {
  return (dispatch) => {
    dispatch(request());

    homeService.saveUserInsurance(insuranceId).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.SAVE_USER_INSURANCE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.SAVE_USER_INSURANCE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.SAVE_USER_INSURANCE_FAILURE, error };
  }
}

function resetZipStatus() {
  return { type: homeConstants.RESET_ZIP_SEARCH, data: null };
}

function getInsuranceDetail(insuranceId) {
  return (dispatch) => {
    dispatch(request());

    homeService.getInsuranceDetail(insuranceId).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.INSURANCE_INFO_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.INSURANCE_INFO_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.INSURANCE_INFO_FAILURE, error };
  }
}

function sortByPrice(value) {
  return { type: homeConstants.SORT_BY_PRICE, data: value };
}

function storeAppData(type, value) {
  if (type === "alternate") {
    return { type: homeConstants.SELECTED_ALTERNATE_LIST, data: value };
  } else if (type === "brandedInfo") {
    return { type: homeConstants.SELECTED_BRANDED_DETAILS, data: value };
  } else if (type === "genericInfo") {
    return { type: homeConstants.SELECTED_GENERIC_DETAILS, data: value };
  }
}

function getPlaystoreLink() {
  return (dispatch) => {
    dispatch(request());

    homeService.getPlaystoreLink().then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.PLAY_STORE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.PLAY_STORE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.PLAY_STORE_FAILURE, error };
  }
}

function getCommunicationPreferences(encUser) {
  return (dispatch) => {
    dispatch(request());

    homeService.getCommunicationPreferences(encUser).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.GET_PREFERRED_COMMUNICATIONS_REQUEST };
  }
  function success(response) {
    return {
      type: homeConstants.GET_PREFERRED_COMMUNICATIONS_SUCCESS,
      response,
    };
  }
  function failure(error) {
    return { type: homeConstants.GET_PREFERRED_COMMUNICATIONS_FAILURE, error };
  }
}

function saveCommunicationPreferences(data) {
  return (dispatch) => {
    dispatch(request());

    homeService.saveCommunicationPreferences(data).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.SAVE_PREFERRED_COMMUNICATIONS_REQUEST };
  }
  function success(response) {
    return {
      type: homeConstants.SAVE_PREFERRED_COMMUNICATIONS_SUCCESS,
      response,
    };
  }
  function failure(error) {
    return { type: homeConstants.SAVE_PREFERRED_COMMUNICATIONS_FAILURE, error };
  }
}

function saveZipCodeToServer(data) {
  return (dispatch) => {
    dispatch(request());

    homeService.saveZipCodeToServer(data).then(
      (response) => {
        dispatch(success(response));
        dispatch(getDeviceDetails());
      },
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.SAVE_ZIP_CODE_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.SAVE_ZIP_CODE_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.SAVE_ZIP_CODE_FAILURE, error };
  }
}

function getGTMDataLayer() {
  return { type: homeConstants.GET_GTM_DATA_LAYER, data: {} };
}

function updateGTMDataLayer(params) {
  return { type: homeConstants.UPDATE_GTM_DATA_LAYER, data: params };
}

function getDeviceDetails() {
  return (dispatch) => {
    dispatch(request());

    homeService.getDeviceDetails().then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.GET_DEVICE_DETAILS_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.GET_DEVICE_DETAILS_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.GET_DEVICE_DETAILS_FAILURE, error };
  }
}

function getAppSettingsIdentity() {
  return (dispatch) => {
    dispatch(request());

    homeService.getAppSettingsIdentity().then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.GET_APP_IDENTITY_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.GET_APP_IDENTITY_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.GET_APP_IDENTITY_FAILURE, error };
  }
}

function resetSettingsIdentity() {
  return { type: homeConstants.RESET_APP_IDENTITY_REQUEST, data: null };
}

function getPrescriptionProducts() {
  return (dispatch) => {
    dispatch(request());

    homeService.getPrescriptionProducts().then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error))
    );
  };

  function request() {
    return { type: homeConstants.PRESCRIPTION_API_REQUEST };
  }
  function success(response) {
    return { type: homeConstants.PRESCRIPTION_API_SUCCESS, response };
  }
  function failure(error) {
    return { type: homeConstants.PRESCRIPTION_API_FAILURE, error };
  }
}
function getFireBaseNotification(value) {
  return { type: homeConstants.GET_FIREBASE_NOTIFICATION, data: value };
}
